export default function ({app, error}) {
  if (!app.$planHasPermission('assign_todo')) {
    return error({
      message: '権限がありません。',
      redirectPath: app.$redirectPathDefault(),
      redirectText: 'メインメニュー'
    });
  }
}